import { useDataSourceTable } from './use_data_source_table'

export const useEfbDataSourceTable = (controller, options) => {
  const config = {
    prefix: 'efb',
    columns: [
      { key: 'name', label: 'Name' },
      { key: 'altitude', label: 'Altitude (m)', precision: 0 },
      { key: 'horVelocity', label: 'H.Vel (m/s)', precision: 0 },
      { key: 'heading', label: 'Heading (°)', precision: 1 }
    ]
  }

  const table = useDataSourceTable(controller, options, config)

  Object.assign(controller, {
    setEfbTableSeparationTarget (entity) {
      table.setSeparationTarget(entity)
    }
  })
}
